export const myDownloadsTranslations = {
  my_downloads_title: 7990,
  my_downloads_subtitle: 7989
};
